import { FaCaretDown, FaCaretRight } from 'react-icons/fa';
import React from 'react';

function defaultHeaderRenderer({ isOpen, headerText }) {
    return (
        <h4>
            {isOpen ? <FaCaretDown /> : <FaCaretRight />} {headerText}
        </h4>
    );
}

export default defaultHeaderRenderer;
